import { render, staticRenderFns } from "./LoaderBloque.vue?vue&type=template&id=09b3c530&scoped=true"
import script from "./LoaderBloque.vue?vue&type=script&lang=js"
export * from "./LoaderBloque.vue?vue&type=script&lang=js"
import style0 from "./LoaderBloque.vue?vue&type=style&index=0&id=09b3c530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b3c530",
  null
  
)

export default component.exports